import { render, staticRenderFns } from "./app-button.vue?vue&type=template&id=435cb2ae"
import script from "./app-button.vue?vue&type=script&lang=ts"
export * from "./app-button.vue?vue&type=script&lang=ts"
import style0 from "./app-button.vue?vue&type=style&index=0&id=435cb2ae&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435cb2ae')) {
      api.createRecord('435cb2ae', component.options)
    } else {
      api.reload('435cb2ae', component.options)
    }
    module.hot.accept("./app-button.vue?vue&type=template&id=435cb2ae", function () {
      api.rerender('435cb2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-button/app-button.vue"
export default component.exports